export default __webpack_public_path__ + "static/leva-incastro-bq-3-17926634896fbadc3ee62aa408bab308.jpg";